module.exports = __webpack_public_path__ + "img/蒋晓飞.cab90275.png";